import type { TopicSource } from '../types/contentCommonTypes';
import type { AccessAction } from '../types/accessTypes';

/** Maps a persisted Topic source to its canonical chapter authorization action. */
export function resolveChapterAccessAction(topicSource: TopicSource): AccessAction {
	if (topicSource === 'private_ai') return 'privateCourse.read';
	if (topicSource === 'github_trending') return 'github.deepDive.open';
	return 'chapter.unlock';
}
